
import Vue from 'vue'

import Command from "@/utils/command";
Vue.use(Command);

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css
import '@/assets/iconfont/iconfont.css' //iconfont图标库
import "@/utils/filters"

import "@/utils/time"
import App from './App'
import store from './store'
import router from '@/utils/router'

import 'vue-ztree-2.0/dist/vue-ztree-2.0.css'

import 'font-awesome/css/font-awesome.min.css'

import "@/utils/directives"

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)


// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.goodsionTip = false


// 保存原始的 window.open 方法
const originalWindowOpen = window.open;

// 重写 window.open 方法
window.open = function(url, target, features) {
    //添加sid
    if(url.indexOf('?sid=') == -1 && url.indexOf('&sid=') == -1 ){
			function getQueryVariable(variable) {
				const query = window.location.search.substring(1);
				const vars = query.split('&');
				for (let i = 0; i < vars.length; i++) {
					const pair = vars[i].split('=');
					if (decodeURIComponent(pair[0]) === variable) {
						return decodeURIComponent(pair[1]);
					}
				}
				return undefined;
			}
			//把当前sid添加进url
			let sid = getQueryVariable("sid");
      if(sid){
        url += (url.indexOf('?') == -1 ? "?" : "&")
        url += `sid=${sid}`
      }
    }
    // 调用原始的 window.open 方法
    return originalWindowOpen.call(window, url, target, features);
};
document.addEventListener('click', function(event) {
  // 判断点击的是否是 <a> 标签
  const link = event.target.closest('a');
  if (link && link.target === '_blank') {
      event.preventDefault(); // 阻止默认的跳转行为
      const url = link.href;
      window.open(url, '_blank');
  }
});

let initialize = async function() {

  //如果已有identity，则先获取identit，menu，feature
  if(localStorage.getItem("identity")){
    try{
      let raclStore = await store.dispatch('racl/get', true);
    }catch(e){
      console.log(e)
    }
  }
  global.gApp = new Vue({
    router,
    store,
    render: h => h(App)
  })

  global.merchApp = global.gApp; 
  global.gApp.config = process.env;	
  global.gApp.$mount("#app");
}
initialize()

